import React  from 'react'

import BreadcrumbsCustom, {
    BreadcrumbCustomItem
} from "../../../../core/gd-components/breadcrumbs/breadcrumbs-custom"

type Props = {
    breadcrumbItems?: BreadcrumbCustomItem[]
}

export default function NewTitleBreadcrumb(props: Props) {
    if (!props.breadcrumbItems) return null

    return (
        <div className="new-form-title">
            <div className="flex-row-left-center p-l-35">
                <BreadcrumbsCustom breadcrumbItems  = {props.breadcrumbItems}
                                   highlightOnHover = {true}/>
            </div>
        </div>
    )
}